import { ApiErrorCode, ApiResponse, withApiErrorHandler } from '@/modules/common/api/errors';
import { mapCustomAttributesFromResponse } from '@/modules/common/mappers/custom-attribute.mapper';
import { CustomAttribute } from '@/modules/common/types/custom-attribute';
import { CustomAttributeResponse } from '@/modules/common/types/dto/response/custom-attribute-response';
import { EntityTypeDTO } from '@/modules/common/types/dto/response/entity-type-dto';
import { axiosInstance } from '@/utils/axios';

export const getCustomAttributesForUsers = async (): Promise<CustomAttribute[]> => {
  const endpoint = '/api/custom-attributes';

  const response = await withApiErrorHandler(
    endpoint,
    ApiErrorCode.CUSTOM_ATTRIBUTES_LOAD_FAILED,
    () =>
      axiosInstance.get<ApiResponse<CustomAttributeResponse[]>>(endpoint, {
        params: { entityType: EntityTypeDTO.USER },
      })
  );

  return mapCustomAttributesFromResponse(response);
};
